<script setup lang="ts">
import { useSidePanel } from '@ui/components/core/p-side-panel/index.js';
import { cn } from '@ui/lib/utils.js';

const { toggle } = useSidePanel();
</script>
<template>
    <button
        data-sidepanel="rail"
        aria-label="Toggle Side Panel"
        tabindex="-1"
        title="Toggle Side Panel"
        @click="toggle"
        :class="
            cn(
                'absolute',
                'inset-y-0',
                'z-20',
                'hidden',
                'w-4',
                '-translate-x-1/2',
                'transition-all',
                'ease-linear',
                'after:absolute',
                'after:inset-y-0',
                'after:left-1/2',
                'after:w-0.5',
                'hover:after:bg-border-default',
                'group-data-[side=left]:-right-4',
                'group-data-[side=right]:left-0',
                'sm:flex',
                '[[data-side=left]_&amp;]:cursor-w-resize',
                '[[data-side=right]_&amp;]:cursor-e-resize',
                '[[data-side=left][data-state=collapsed]_&amp;]:cursor-e-resize',
                '[[data-side=right][data-state=collapsed]_&amp;]:cursor-w-resize',
                'group-data-[collapsible=offcanvas]:translate-x-0',
                'group-data-[collapsible=offcanvas]:after:left-full',
                'group-data-[collapsible=offcanvas]:hover:bg-border-default',
                '[[data-side=left][data-collapsible=offcanvas]_&amp;]:-right-2',
                '[[data-side=right][data-collapsible=offcanvas]_&amp;]:-left-2',
            )
        "
    ></button>
</template>
